/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API SSO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetAccountByUserIdRequestDto } from '../models';
// @ts-ignore
import type { TelegramAuthRequestDto } from '../models';
// @ts-ignore
import type { TelegramAuthResponseDto } from '../models';
/**
 * TELEGRAMApi - axios parameter creator
 * @export
 */
export const TELEGRAMApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение телеграмм аккаунта пользователем
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramControllerGetMeTelegram: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/telegram/getMe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение телеграмм аккаунта админом
         * @param {GetAccountByUserIdRequestDto} getAccountByUserIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramControllerGetTelegramAccountByUserId: async (getAccountByUserIdRequestDto: GetAccountByUserIdRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAccountByUserIdRequestDto' is not null or undefined
            assertParamExists('telegramControllerGetTelegramAccountByUserId', 'getAccountByUserIdRequestDto', getAccountByUserIdRequestDto)
            const localVarPath = `/telegram/getAccountByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAccountByUserIdRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Выход из телеграмм аккаунта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramControllerLogoutTelegram: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/telegram/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Привязка телеграмм аккаунта
         * @param {TelegramAuthRequestDto} telegramAuthRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramControllerSignupTelegram: async (telegramAuthRequestDto: TelegramAuthRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'telegramAuthRequestDto' is not null or undefined
            assertParamExists('telegramControllerSignupTelegram', 'telegramAuthRequestDto', telegramAuthRequestDto)
            const localVarPath = `/telegram/signUp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(telegramAuthRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TELEGRAMApi - functional programming interface
 * @export
 */
export const TELEGRAMApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TELEGRAMApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение телеграмм аккаунта пользователем
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telegramControllerGetMeTelegram(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelegramAuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telegramControllerGetMeTelegram(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TELEGRAMApi.telegramControllerGetMeTelegram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение телеграмм аккаунта админом
         * @param {GetAccountByUserIdRequestDto} getAccountByUserIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telegramControllerGetTelegramAccountByUserId(getAccountByUserIdRequestDto: GetAccountByUserIdRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelegramAuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telegramControllerGetTelegramAccountByUserId(getAccountByUserIdRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TELEGRAMApi.telegramControllerGetTelegramAccountByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Выход из телеграмм аккаунта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telegramControllerLogoutTelegram(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telegramControllerLogoutTelegram(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TELEGRAMApi.telegramControllerLogoutTelegram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Привязка телеграмм аккаунта
         * @param {TelegramAuthRequestDto} telegramAuthRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telegramControllerSignupTelegram(telegramAuthRequestDto: TelegramAuthRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telegramControllerSignupTelegram(telegramAuthRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TELEGRAMApi.telegramControllerSignupTelegram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TELEGRAMApi - factory interface
 * @export
 */
export const TELEGRAMApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TELEGRAMApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение телеграмм аккаунта пользователем
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramControllerGetMeTelegram(options?: RawAxiosRequestConfig): AxiosPromise<TelegramAuthResponseDto> {
            return localVarFp.telegramControllerGetMeTelegram(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение телеграмм аккаунта админом
         * @param {GetAccountByUserIdRequestDto} getAccountByUserIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramControllerGetTelegramAccountByUserId(getAccountByUserIdRequestDto: GetAccountByUserIdRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TelegramAuthResponseDto> {
            return localVarFp.telegramControllerGetTelegramAccountByUserId(getAccountByUserIdRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Выход из телеграмм аккаунта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramControllerLogoutTelegram(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.telegramControllerLogoutTelegram(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Привязка телеграмм аккаунта
         * @param {TelegramAuthRequestDto} telegramAuthRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramControllerSignupTelegram(telegramAuthRequestDto: TelegramAuthRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.telegramControllerSignupTelegram(telegramAuthRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TELEGRAMApi - object-oriented interface
 * @export
 * @class TELEGRAMApi
 * @extends {BaseAPI}
 */
export class TELEGRAMApi extends BaseAPI {
    /**
     * 
     * @summary Получение телеграмм аккаунта пользователем
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TELEGRAMApi
     */
    public telegramControllerGetMeTelegram(options?: RawAxiosRequestConfig) {
        return TELEGRAMApiFp(this.configuration).telegramControllerGetMeTelegram(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение телеграмм аккаунта админом
     * @param {GetAccountByUserIdRequestDto} getAccountByUserIdRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TELEGRAMApi
     */
    public telegramControllerGetTelegramAccountByUserId(getAccountByUserIdRequestDto: GetAccountByUserIdRequestDto, options?: RawAxiosRequestConfig) {
        return TELEGRAMApiFp(this.configuration).telegramControllerGetTelegramAccountByUserId(getAccountByUserIdRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Выход из телеграмм аккаунта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TELEGRAMApi
     */
    public telegramControllerLogoutTelegram(options?: RawAxiosRequestConfig) {
        return TELEGRAMApiFp(this.configuration).telegramControllerLogoutTelegram(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Привязка телеграмм аккаунта
     * @param {TelegramAuthRequestDto} telegramAuthRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TELEGRAMApi
     */
    public telegramControllerSignupTelegram(telegramAuthRequestDto: TelegramAuthRequestDto, options?: RawAxiosRequestConfig) {
        return TELEGRAMApiFp(this.configuration).telegramControllerSignupTelegram(telegramAuthRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

